import type { ModalType } from "../../../../common-deprecated/redux/reducers/ModalReducer";
import { MODAL_ORDER_CHECKOUT } from "./modalConstants";

export const isCheckoutModalActive = (modals: ModalType[], checkoutType: "buy" | "lease" | "reserve"): boolean => {
    return !!modals.find(
        ({ settings, show }) =>
            settings?.type === MODAL_ORDER_CHECKOUT && settings?.checkoutType === checkoutType && show,
    );
};
